<template>
  <transition name="modal-fade">
    <div @click="close()" class="modal-backdrop">
      <div @click.stop="" class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">
            <img src="../../assets/logo-essi-expert.svg" />
            <h2>{{ header }}</h2>
            <button type="button" class="btn-close" @click="close()" aria-label="Close modal">
              <img class="logo-close" src="../../assets/ic-close.svg" />
            </button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <Step1 v-if="currentStep === 1" />
            <Step2 v-if="currentStep === 2" />
            <Step3 v-if="currentStep === 3" />
            <Step4 v-if="currentStep === 4" />
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <ModalStepFooter @stepChanged="changeStep" :selected="currentStep" />
            <p>{{ footer }}</p>
          </slot>
        </footer>
        <button v-if="currentStep !== 4" @click="currentStep += 1" type="button" class="btn-next">
          <img src="../../assets/rigth-arrow.png" />
        </button>
        <button v-if="currentStep !== 1" @click="currentStep -= 1" type="button" class="btn-prev">
          <img src="../../assets/rigth-arrow.png" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Step1 from '../Tutos/Step1';
import ModalStepFooter from '../Tutos/ModalStepFooter';
import Step2 from '../Tutos/Step2';
import Step3 from '../Tutos/Step3';
import Step4 from '../Tutos/Step4';
export default {
  name: 'ModalHelpScreen',
  components: { Step4, Step3, Step2, ModalStepFooter, Step1 },
  props: ['content', 'header', 'footer'],
  methods: {
    close() {
      this.$emit('close');
    },
    changeStep(stepNumber) {
      this.currentStep = stepNumber;
    },
  },
  data: () => {
    return {
      currentStep: 1,
    };
  },
};
</script>

<style scoped>
.modal-backdrop {
  z-index: 2000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  width: 40%;
  min-width: 750px;
  height: 90%;
  background: #ffffff;
  overflow-x: auto;
  border: solid 2px #0088ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  color: black;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex: 1;
}
.modal-header h2 {
  padding-top: 20px;
  font-size: 20px;
}

.modal-footer {
  padding-top: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
}

.modal-body {
  width: 100%;
  position: relative;
  padding: 20px 10px;
  flex: 1;
}

.btn-close {
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-next {
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 5px;
}

.btn-prev {
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 5px;
}

.btn-prev {
  transform: rotate(180deg);
}

.btn-close img {
  width: 30px;
  filter: invert(35%) sepia(54%) saturate(1964%) hue-rotate(182deg) brightness(101%) contrast(106%);
}

.logo-close {
  border: solid 2px black;
  border-radius: 24px;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
